import { useQuery } from '@tanstack/react-query'
import { QueryKey } from 'src/reactQuery/enums/queryKey.enum'
import { AnalyticsApi } from 'src/services/analyticsApi'
import { AnalyticsFetchRadarChartResponse } from 'src/services/__generated__/api'
import { UseGetRadarChartParams } from './interfaces/useGetRadarChartQuery.interface'

const getRadarChart = async (
  start?: string,
  end?: string
): Promise<AnalyticsFetchRadarChartResponse | null> => {
  const { data } = await AnalyticsApi.v1Private.analyticsFetchRadarChartList({
    fromDate: start,
    toDate: end,
  })

  return data
}

export const useGetRadarChartQuery = (params: UseGetRadarChartParams) => {
  return useQuery({
    queryFn: () => getRadarChart(params.start, params.end),
    queryKey: [QueryKey.GET_RADAR_CHART, params.start, params.end],
  })
}
